import React, { Component }     from 'react';
import PropTypes                from 'prop-types';
import Modal                    from '../Modal';
import {
  IFRAME_PAGE_STYLE,
} from './styles';
import {
  BLACK,
} from "../../config/colors";
import { CloseIcon } from "../../icons";

const styles = {
  closeIconWrap: { position: 'absolute', right: 10, top: 10, cursor: 'pointer', zIndex: 10 },
  closeIcon: { height: '35px', width: '35px', color: BLACK },
};

class MsoPaymentIframeModal extends Component {

  render() {

    const {
      hideModal,
      paymentUrl
    } = this.props;

    return (
      <Modal
        isOpened
        paddingTop="65px"
        overlayTop={0}
        closeOnOverlayClick
        closeOnOutsideClick
        onClose={() => {
          hideModal()
        }
        }
      >
        <div onClick={hideModal} style={styles.closeIconWrap}><CloseIcon style={styles.closeIcon} color={BLACK} /></div>
        <iframe src={paymentUrl} style={IFRAME_PAGE_STYLE} frameBorder="0"/>
      </Modal>
    );
  }
}

MsoPaymentIframeModal.propTypes = {
  paymentUrl: PropTypes.string.isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default MsoPaymentIframeModal;



// WEBPACK FOOTER //
// ./src/components/MsoPaymentModal/MsoPaymentIframeModal.jsx